import { CallServices, CoreServices } from "./apiServices";
import {
  ClearStorage,
  GetItemFromStorage,
  SetItemInStorage,
} from "../../custom_hooks/useStorage";
import { Cookie, MapAgentTrackerData, getTime, hassAccess, insertUpdateAgentAssist, isJSON, summarySubjectHandler, summarySubjectHandlerForCall } from "../utils";
import {
  getContactDetails,
  getDispositionForCustomers,
  getNecessaryDetails,
  getNecessaryDetailswithsession,
  getSessionById,
  updateContactinSession,
} from "../../store/api/helperspi/contactListapiService";

import { AgentStateAction } from "../../store/slices/agent-status/agent_state";
import { ApiServices } from "../../services/api_services";
import { CALLURL } from "../../constants/api_constants";
import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import { LiveTrackerActions } from "../../store/slices/live_tracker";
import { supervisorContactDataSliceActions } from "../../store/slices/supervisor_contact/contactsData";
import { GetAlluserActions } from "../../store/slices/user_management/get_all_users";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { Types } from "../action/action";
import _ from "lodash";
import { agentTrackerActions } from "../../store/slices/trackerStatus_slice/agentTrackerslice";
import { agentstatusListAction } from "../../store/slices/agent-status/agent-status";
import { UserSettingsActions } from '../../store/slices/settings_slice/user_settings_slice';
import { allActivityActions } from "../../store/slices/all_activity_slice/all_activity_slice";
import { cochatDetailsActions } from "../../store/slices/cochat_slice/cochat_channel_details_slice";
import { DOMAINID, ROLES, config } from "../constant";
import { getUser } from "../../constants/base/utils";
import jwt_decode from "jwt-decode";
import { newEmailEntriesSliceActions } from "../../store/slices/new_emailEntries/newEmailEntries";
import { queueTrackerActions } from "../../store/slices/trackerStatus_slice/queueTrackerslice";
import socketIOClient from "socket.io-client";
import store from "../../store/redux-store/root_store";
import { v4 as uuidv4 } from "uuid";
import { CallService } from "../../services/call_service";
import { getAllUsers } from "../../store/api/user_management";
import { message } from "antd";
import { dispositionSliceActions } from "../../store/slices/dispositionSlice/postDisposition";
import { SocialmediaWidgetActions } from "../../store/slices/socialmediaWidget";
import presenceService from "./presence";
import { dashBoardSliceActions } from "../../store/slices/dashboard_slice/dashBoard";
import { useSelector } from "react-redux";
import { ChatState } from "../../base/models/model";
import moment from "moment";
import { ReportServices } from "../../base/service/apiServices";
import { getLiveSessions } from "../../components/contact/base/utils";
import { EdituserDetailsActions } from "../../store/slices/user_management/edit_user";
import { setDataInLocalStorage } from "../../utils/storage";
import { getDashboardCallDatalive, getDashboardEmailDatalive, getDashboardSmsDatalive, getDashboardSocialmediaDatalive } from "../../store/helpers/dashboard";
import { data } from "jquery";
import { setCallNotification } from "../../store/slices/main_layout_slice/notification";
import { ChatReducerWrapper } from "../../store/redux-store/reset_action";
import { updateAgentState } from "../../store/api/agent_status";
import { DynamicDashboardSliceActions } from "../../store/slices/dynamicDash_slice";
import { LOGIN_USER } from "../../constants/reducer_names";
import { EndCall } from "unifiedring-sdk/lib/Call";
import { outboundCampaignSliceAction } from "../../store/slices/outboundCampaign/outboundCampaignslice";
import { LoginActions } from "../../store/slices/authentication_slice/login_slice";
import { Cookies } from "../../utils/cookies";
import { getPriviousChannelSummary } from "../../components/webChatScreen/utils";
import { getSentimentalCustomer_Call, getSentimentalCustomer_chat, getSentimentalCustomer_socialmedia } from "../../store/helpers/nlpapi";

export default class callChatService {
  public static io: any;
  static _instance: any;
  private static hist: any;
  constructor(token: any, navigate: any, dispatch: any) {
    let userData: any = jwt_decode(token);
    const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const { callBackTimerFunc, SupervisorEndCall } = CallService(dispatch, navigate);
    const { createCallConnection, CallOutboundCampaignFunction, dialPadChanges } = CallService(dispatch, navigate);

    if (callChatService.io) {
      console.log("Disconnecting previous socket", callChatService.io);
      callChatService.io.disconnect();
    }
    callChatService.io = socketIOClient(config().BASE_URL, {
      // callChatService.io = socketIOClient("http://localhost:5008", {
      path: "/ccascall-service",
      auth: { token: token, id: `${userData?.domainId}_${userData?.ext}` },
      transports: ["websocket"],
    });

    callChatService.io.on("connect", () => {
      console.log("socket", `${userData?.domainId}_${userData?.ext}`);
      console.log("socket connected");
      const data = { domainId: userData?.domainId, ext: userData?.ext };
      callChatService.io.emit("agent_ext_socket_id_mapping", data);
    });

    callChatService.io.on("disconnect", (reason: any) => {
      Cookies.clearKey('allowMultipleLogin');
      console.warn("socket disconnect", userData?.domainId, userData?.ext, '>>>>', reason);
    });

    callChatService.io.on("connect_error", (msg: any) => {
      if (msg && msg?.message && isJSON(msg?.message)) {
        const parsedMessage: any = JSON.parse(msg?.message);
        if (parsedMessage?.code === 403) {
          Cookie.clear();
          navigate("/login");
          ClearStorage();
          localStorage.clear();
          sessionStorage.clear();
          callChatService.destroy();
        }
      }
    });

    // email ====>

    callChatService.io.on("email_channel_emit", (msg: any) => {
      dispatch(
        newEmailEntriesSliceActions.checkNewEmail({
          checkEmailArray: msg,
          isNewEmailEntry: true,
        })
      );
    });

    callChatService.io.on("dispositionCreated", (message: any) => {
      dispatch(getDispositionForCustomers());
    });

    callChatService.io.on('refreshNotification', () => {
      dispatch(UserSettingsActions.setRefreshNotification())
    })

    callChatService.io.on("agentassist", (message: any) => {

      let { sessionList } = store.getState().chatReducer;
      sessionList?.map((list: any) => {
        if (list?.sessionId === message?.sessionId) {
          message["timeStamp"] = new Date().getTime();
          let dataassist = {
            ...message,
            AssistMsg: {
              // assistMsg: message,
              isLike: 0,
              isDislike: 0,
              isUsed: 0,
            },
            NoOfUsedAssistMsg: 0,
            totalNoOfassist: 1,
          };

          dispatch(ChatActions.agaentAssitence(dataassist));
          const data = {
            AssistMsg: {
              assistMsg: message.response,
              isLike: 0,
              isDislike: 0,
              isUsed: 0,
              messageId: message?.messageId ?? null
            },
            NoOfUsedAssistMsg: 0,
            totalNoOfassist: 1,
            isUpdate: 0
          }
          insertUpdateAgentAssist(data);
        }
      });
    });


    callChatService.io.on("SentimentScoreAnalytics", (message: any) => {
      let { sessionList, currentSession, currentEndSession } =
        store.getState().chatReducer;
      console.log("SentimentScoreAnalytics>>>>>>", currentSession, message);

      if (
        currentSession?.channelType == "Whatsapp" &&
        currentSession?.WhatsappHistoryId == message?.data?.WhatsappHistoryId
      ) {
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
        console.log("message>>>>>>", "Whatsapp");
      } else if (
        currentSession?.channelType == "Sms" &&
        currentSession?.SMSHistoryId == message?.data?.SMSHistoryId
      ) {
        console.log("message>>>>>>", "Sms");
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
      } else if (
        currentSession?.channelType == "Email" &&
        currentSession?.EmailHistoryId == message?.data?.EmailHistoryId
      ) {
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
        console.log("message>>>>>>", "Email");
      } else if (
        currentSession?.channelType == "Facebook" &&
        currentSession?.FacebookHistoryId == message?.data?.FacebookHistoryId
      ) {
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
        console.log("message>>>>>>", "Facebook");
      } else if (
        currentSession?.channelType == "Instagram" &&
        currentSession?.InstagramHistoryId == message?.data?.InstagramHistoryId
      ) {
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
        console.log("message>>>>>>", "Instagram");
      } else if (currentSession?.sessionId == message?.data?.sessionId) {
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
      } else if (message?.data?.meetingId == currentSession?.sessionId) {
        console.log(message?.data?.meetingId == currentSession?.sessionId, "meeting id")
        dispatch(
          ChatActions.setSpeedometerScoreChat(message?.speedometerScore)
        );
      } else {
        dispatch(ChatActions.setSpeedometerScoreChat(0));
      }
      // if(currentEndSession === message?.data.sessionId){
      //    dispatch(ChatActions.setSpeedometerScoreChat(message?.speedometerScore))
      // }
    });

    callChatService.io.on("webscrapresponse", (message: any) => {
      let data: any = [];
      data.push(message);
      // message['timeStamp'] = new Date().getTime();
      dispatch(ChatActions.webscrapProcess(data));
    });
    /// email -----

    callChatService.io.on("clientInfo", (message: any) => { });

    callChatService.io.on("agentStartTimeResponse", (message: any) => {
      dispatch(ChatActions.agentTimeResponse(message));
    });

    callChatService.io.on("webchatLiveDashboard", (message: any) => {
      dispatch(dashBoardSliceActions.chatData(message));
    });

    callChatService.io.on("agentstatusDashboard", (message: any) => {
      dispatch(dashBoardSliceActions.agentData(message));
    });

    callChatService.io.on("updated_webchat_LiveDashboard", (message: any) => {
      if (["/dynamicdashboard", "/agentdashboard", "/agentdashboardstandalone", "/standaloneDashboard"].includes(window.location.pathname)) {
        let today = moment().format("YYYY-MM-DD");
        let startTimestampInSeconds = moment
          .utc(`${today} 00:00:00`, "YYYY-MM-DD HH:mm:ss")
          .valueOf();
        let todayStart = moment().format("YYYY-MM-DD");
        let toTimestampInSeconds = moment
          .utc(`${todayStart} 23:59:59`, "YYYY-MM-DD HH:mm:ss")
          .valueOf();
        const body = {
          startTmpstmp: startTimestampInSeconds,
          endTmpstmp: toTimestampInSeconds,
        };
        ReportServices.post(body, "/get_webchat_live_dashboard");
      }
    });

    callChatService.io.on("AGENT_REGISTER", (data: any) => {
      SetItemInStorage("register", "1");
      dispatch(CallPopUpAgentActions.setagentRegisterDetails(data));
      createCallConnection();
    });

    callChatService.io.on("customer_end_session", (data: any) => {
      let { sessionList, currentSession } = store.getState().chatReducer;
      // let SessionFilterData: any = {};
      dispatch(dispositionSliceActions.setDispositionSessionId(data?.sessionId));
      if (currentSession?.sessionId !== data?.sessionId) {
        sessionList?.map((list: any) => {
          if (list?.sessionId === data?.sessionId) {
            if (window.location.pathname !== "/chatscreenagent") {
              navigate("/chatscreenagent");
            }
            // SessionFilterData = list
            const textClr: any = document.getElementById("textedited");
            if (textClr !== "" && textClr !== null) {
              textClr.textContent = "";
              textClr.innerHTML = "";
              textClr.focus();
            }
            let current_data = { ...list, isInteractionView: false };
            // dispatch(ChatActions.chatAgentAssistListReset());
            dispatch(ChatActions.chatAgentAssistReload(true));
            dispatch(ChatActions.currentChatSession(current_data));
            dispatch(ChatActions.storeCurrentSessionMsgHistory(current_data));
            dispatch(ChatActions.setCurrentEndSession(data?.sessionId));
            // dispatch(ChatActions.setAiSummaryStatus(true));
            hassAccess('Disposition/regenerate') && summarySubjectHandler(current_data, dispatch, 0);
            dispatch(
              dispositionSliceActions.setChatDispositionOpen({
                isChatDisPositionStatus: true,
              })
            );
          }
        });
      } else {
        if (window.location.pathname !== "/chatscreenagent") {
          navigate("/chatscreenagent");
        }
        dispatch(ChatActions.setCurrentEndSession(data?.sessionId));
        // dispatch(ChatActions.setAiSummaryStatus(true))
        hassAccess('Disposition/regenerate') && summarySubjectHandler(currentSession, dispatch, 0);
        dispatch(
          dispositionSliceActions.setChatDispositionOpen({
            isChatDisPositionStatus: true,
          })
        );
      }
      let result = sessionList?.map((list: any) => {
        if (list?.sessionId === data?.sessionId) {
          return {
            ...list,
            isChatEnded: 1
          };
        }
        return list
      })
      dispatch(ChatActions.meetSessionList(result));
      //dispatch(ChatActions.updateCurrentEndSession(1));
    });

    callChatService.io.on("transferChatAccepted", async (message: any) => {
      let InterValData: any;
      let { started, storeInterval }: any = store.getState().dispositionData;
      let { dispositionTagList }: any = store.getState().contactListForAgent;
      let { currentSession } = store.getState().chatReducer;
      let transferId: any = {};
      let completeDisposition: any = {};
      dispositionTagList?.map((list: any) => {
        if (list?.dispositionName === "Transferred") {
          transferId = list?.did;
          completeDisposition = list;
          return;
        }
      });
      console.log('primaryAgent::::::::')
      if (message?.primaryAgent === `${userData?.domainId}_${userData?.ext}`) {
        dispatch(ChatActions.updateTransferModalStatus({
          ChatHistoryId: message?.ChatHistoryId,
          istransferringmodal: true,
          istransferring: false,
          istransferSuccess: true,
          istransferDeclined: false
        }))
        const init = () => {
          dispatch(ChatActions.updateTransferModalStatus({
            ChatHistoryId: message?.ChatHistoryId,
            transferName: '',
            istransferringmodal: false,
            istransferring: false,
            istransferSuccess: false,
            istransferDeclined: false
          }))
          dispatch(ChatActions.transferAcceptDetails(message));
          dispatch(ChatActions.setCurrentEndSession(message?.to));
          // dispatch(ChatActions.setAiSummaryStatus(true))
          hassAccess('Disposition/regenerate') && summarySubjectHandler(currentSession, dispatch, 1);
          dispatch(
            dispositionSliceActions.setChatDispositionOpen({
              isChatDisPositionStatus: true,
            })
          );
          dispatch(
            dispositionSliceActions.setDisposition({
              key: completeDisposition,
            })
          );
          dispatch(ChatActions.currentTransferState(1));
          dispatch(ChatActions.updateCurrentTransferState(1));
          dispatch(dispositionSliceActions.startDispositionTimer());
          dispatch(dispositionSliceActions.setDispositionId(transferId));
          if (!started) {
            clearInterval(storeInterval);
            InterValData = setInterval(() => {
              dispatch(dispositionSliceActions.startDispositionTimer());
            }, 1000);
            dispatch(dispositionSliceActions.storeIntervalData(InterValData));
          }
        }

        setTimeout(() => {
          init()
        }, 2000)
      }
    });

    callChatService.io.on("OneToOneChatReceive", (message: any) => {
      let { sessionList, currentSession } = store.getState().chatReducer;
      if (message?.to === `${userData?.domainId}_${userData?.ext}`) {
        dispatch(ChatActions.agentAddMessage(message));
        dispatch(ChatActions.customerDetails({ message: message?.sender }));
        dispatch(ChatActions.storeCurrentSessionMsgHistory(message));
        dispatch(ChatActions.setUnreadMessageCount(message));
        if (hassAccess('sentimentalAnalysis')){
          getSentimentalCustomer_chat(message, dispatch);
        }
        // const currentSession_=sessionList.filter((data:any)=>data?.ChatHistoryId == message?.ChatHistoryId)
        // dispatch(ChatActions.currentChatSession(currentSession_[0]));
      }
    });

    callChatService.io.on("OneToOneCallReceive", (message: any) => {
      // message["timeStamp"] = new Date().getTime();
      console.log(message, "message====");
      let msg = { ...message, sendAt: new Date().getTime() }
      dispatch(ChatActions.agentAddMessage(msg));
      dispatch(ChatActions.customerDetails({ message: msg?.sender }));
      dispatch(ChatActions.storeCurrentSessionCallHistory(msg));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(msg));
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_Call(msg, dispatch);
      }
    });

    callChatService.io.on("supervisor_trackerview_chat", (message: any) => {
      let { supervisorWhisperStatus } = store.getState().chatReducer;
      if (
        ["view", "whisper"].includes(supervisorWhisperStatus) &&
        (loginUserCcaasDetail?.roleid == "5" || loginUserCcaasDetail?.roleid == 3) &&
        message?.supervisorList !== undefined &&
        message?.supervisorList?.length > 0
      ) {
        dispatch(ChatActions.agentAddMessage(message));
        dispatch(ChatActions.customerDetails({ message: message?.sender }));
        dispatch(ChatActions.storeCurrentSessionMsgHistory(message));
      }
    });

    callChatService.io.on("getAgentTracker", (data: any) => {
      if (loginUserCcaasDetail?.roleid == ROLES?.ADMIN_ROLE_ID || loginUserCcaasDetail?.roleid == ROLES?.SUPERVISOR_ROLE_ID) {
        getLiveSessions(dispatch);
      }
    });

    callChatService.io.on("updateAgentRoutingProfile", (data: any) => {
      const userDetail = GetItemFromStorage('LOGIN_USER_CCAAS_DETAILS');
      console.log('updateAgentRoutingProfile', data, userDetail);
      console.log('+(data?.ext)', typeof +(data?.ext));
      console.log('+(userDetail?.ext)', typeof +(userDetail?.ext));
      console.log('+(data?.domainId)', typeof +(data?.domainId));
      console.log('+(userDetail?.domainId)', typeof +(userDetail?.domainId));

      if (+(data?.ext) === +(userDetail?.ext) && +(data?.domainId) === +(userDetail?.domainId)) {
        console.log('if');
        const loginData = { ...userDetail, routing_profile_id: data?.id };
        // SetItemInStorage('LOGIN_USER_CCAAS_DETAILS', JSON.stringify(loginData));
        SetItemInStorage('LOGIN_USER_CCAAS_DETAILS', loginData);
      }
    });

    callChatService.io.on("customerTyping", (data: any) => {
      dispatch(ChatActions.textTyping(data.isTyping));
    });

    callChatService.io.on("typingBotText", (data: any) => {
      dispatch(ChatActions.typingBotText(data));
    });

    callChatService.io.on("presenceStatusrestriction", async (data: any) => {
      dispatch(updateAgentState());

      // const agentStatus = await CoreServices.get("/get_agent_status")
      // if (agentStatus?.data?.getAgentListRes) {
      //   dispatch(AgentStateAction.setAgentStatus(agentStatus.data.getAgentListRes))
      // }
    });

    callChatService.io.on("updateUserManagement", async (data: any) => {
      dispatch(GetAlluserActions.updateTableData(data));
      console.log("loginUserCcaasDetail", loginUserCcaasDetail, data?.emailId === loginUserCcaasDetail?.emailId, userData, " data?.emailId === userData?.Email", data?.emailId === userData?.Email)
      if (data?.emailId === loginUserCcaasDetail?.emailId || data?.emailId === userData?.Email)
        dispatch(outboundCampaignSliceAction.setUserCallInfo(data?.outboundCampaignCall))

    });

    callChatService.io.on("chatAcceptedDeviceTypeListener", (data: any) => {
      if (data?.deviceType !== "Web") {
        const ringer: any = document.getElementById("ringer");
        ringer.pause();
        dispatch(ChatActions.declineChat());
      }
    });

    callChatService.io.on("chatDeclinedDeviceTypeListener", (data: any) => {
      if (data?.deviceType !== "Web") {
        const ringer: any = document.getElementById("ringer");
        ringer.pause();
        dispatch(ChatActions.declineChat());
        dispatch(ChatActions.closeTransferModalStatus({ ChatHistoryId: data.ChatHistoryId }));
      } else {
        dispatch(ChatActions.closeTransferModalStatus({ ChatHistoryId: data.ChatHistoryId }));
      }
      dispatch(ChatActions.updateTransferModalStatus({
        ChatHistoryId: data.ChatHistoryId,
        istransferringmodal: true,
        istransferring: false,
        istransferSuccess: false,
        istransferDeclined: true,
      }));
      setTimeout(() => {
        dispatch(ChatActions.updateTransferModalStatus({
          ChatHistoryId: data.ChatHistoryId,
          transferName: '',
          istransferringmodal: false,
          istransferring: false,
          istransferSuccess: false,
          istransferDeclined: false,
        }));
      }, 2000);
    });
    callChatService.io.on("socialMediaDeclinedDeviceTypeListener", (data: any) => {
      if (data?.deviceType !== "Web") {
        const ringer: any = document.getElementById("ringer");
        ringer.pause();
        dispatch(SocialmediaWidgetActions.setSocialmediaInvite(false));

        // dispatch(ChatActions.declineChat());
        // dispatch(ChatActions.closeTransferModalStatus({ ChatHistoryId: data.ChatHistoryId }));
      } else {
        console.log("socialMediaDeclinedDeviceTypeListener error")
      }

    });
    callChatService.io.on("markAsSeen", (data: any) => {
      dispatch(ChatActions.seenHandler(data));
    });

    callChatService.io.on("queue_name_update", (data: any) => {
      if (data.domainId === userData?.domainId) {
        const commonReducer: any = store.getState().queueTracker;
        let { queueTrackerData } = commonReducer;
        const fiterData: any = queueTrackerData.map((list: any) => {
          if (list?.qid === data?.qid) {
            list = { ...list, queueName: data?.name };
          }
          return list;
        });

        dispatch(
          queueTrackerActions.queueTrackerData({ queueTrackerData: fiterData })
        );
      }
    });

    callChatService.io.on("connect", (message: any) => {
      dispatch(ChatActions.updateSocketConnect());
    });
    const showDetials = async (data: any) => {
      return await getSessionById(data.sessionId, data?.channelType)
    };
    callChatService.io.on("newLoginUpdate", (message: any) => {
      if (['CCAAS:BROWSER', 'TICKETING_BROWSER'].includes(message?.source)) {
        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        const uuid = GetItemFromStorage("uuid");
        const loginTime = GetItemFromStorage(LocalStorage.LOGIN_TIME);
        const { currentSession } = store.getState().chatReducer;
        const { dispositionTagList } = store.getState().contactListForAgent;
        const loginDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
        if (
          message?.ext?.toString() === userDetails?.ext?.toString() &&
          message?.domainId === userDetails?.domain_id
        ) {
          if (message?.loginTime !== loginTime) {
            const popUpDetails = store.getState().callPopUpDetails;
            EndCall(popUpDetails.incomingCallDetail.useragent);
            const date = new Date();
            if (uuid !== "") {
              const body = {
                logOutTimestamp: date.getTime(),
                logInSessionId: uuid,
              };
              CoreServices.put(body, `/update_login_session_history`).catch(
                (e: any) => console.error(e)
              );
            }
            if (Object.keys(currentSession).length !== 0) {
              const mapData = (data: any) => {
                return {
                  colorCode: data?.colorCode,
                  description: data?.description,
                  did: data?.did,
                  dispositionName: data?.dispositionName,
                  domainId: data?.domainId,
                  status: data?.status,
                  type: data?.type,
                  updateAt: new Date(),
                  loginUser: userDetails?.profileName
                };
              };
              const dis: any = dispositionTagList?.find((i: { dispositionName: any }) => i.dispositionName === 'Closed');
              const data: any = {
                domainId: userDetails?.domainId,
                ext: userDetails?.ext,
                sessionId: currentSession?.sessionId,
                summary: null,
                disposition: mapData(dis),
                dispositionName: 'Closed',
                afterCallWorkTime: 0,
                calledPersonDetails: currentSession?.calledPersonDetails ?? {},
                subject: null,
                updateAt: Date.now(),
                channelType: currentSession?.channelType ? currentSession?.channelType : currentSession?.channeltype ? currentSession?.channeltype : currentSession?.ChatHistoryId ? 'Chat' : null,
                ChatDurationHistoryId: currentSession?.ChatDurationHistoryId,
                dispositionId: dis?.did,
                agentOccupyDetails: null,
                isTicketing: false,
                isSessionClosed: 1,
                afterWorkTime: 0,
                dispositionUpdatedBy: loginDetails.UserID,
                duration: currentSession?.sessionOnGoingTime,
                dispositionSubject: null,
                WhatsappHistoryId: currentSession?.WhatsappHistoryId,
                FacebookHistoryId: currentSession?.FacebookHistoryId,
                InstagramHistoryId: currentSession?.InstagramHistoryId,
              };

              const stringifiedData = JSON.stringify(data);
              console.log('Sending API request before unload', data);
              navigator.sendBeacon(`${CALLURL}/update_disposition_beforeunload`, stringifiedData);
            }
            const ringer: any = document.getElementById("ringer");
            if (ringer) ringer.pause();
            dispatch({ type: `${LOGIN_USER}/logout` });
            localStorage.clear();
            sessionStorage.clear();
            Cookie.clear();
            dispatch(LoginActions.setLoginError('Your account has been logged in from another device'));
            navigate("/");
            ClearStorage();
            callChatService.destroy()
            presenceService.destroy()
          }
        }
      }
    });

    callChatService.io.on("webChatConnected", (message: any) => {
      try {
        const roomData: any = store.getState().chatReducer;
        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        if (!roomData.isIncomingChat) {
          if (message.agentId === `${userData?.domainId}_${userData?.ext}` && roomData?.currentSession?.sessionId?.trim() !== message?.userId?.trim()) {
            dispatch(
              getNecessaryDetails({
                contact: message?.sender["coid"],
                sessionId: message?.userId.trim(),
              })
            )
              .unwrap()
              .then((response: any) => {
                if (response?.contact?.data?.statusCode === 200) {
                  message["contactDetails"] =
                    response.contact.data.getContactDetailsRes.length > 0
                      ? response.contact.data.getContactDetailsRes[0]
                      : {};
                } else {
                  message["contactDetails"] = {};
                }

                if (response?.sessionDetail?.data?.statusCode === 200) {
                  console.log(
                    "response?.sessionDetail?.data?.statusCode",
                    response?.sessionDetail?.data
                  );
                  message["queueName"] =
                    response.sessionDetail.data.getSessionDetailsRes.length > 0
                      ? response.sessionDetail.data.getSessionDetailsRes[0]
                        .queueName
                      : "";
                } else {
                  message["queueName"] = "";
                }

                dispatch(ChatActions.incomingChat(message));
                let ringer: any = document.getElementById("ringer");
                if (ringer) {
                  ringer?.play();
                  ringer.muted = false;
                  // if (document.hasFocus()) {
                  //   ringer?.play();
                  //   ringer.muted = false;
                  // } else {
                  //   const ans = window.confirm(
                  //     "Do you want to enable chat ringtone?"
                  //   );
                  //   if (ans) {
                  //     ringer?.play();
                  //     ringer.muted = false;
                  //   }
                  // }
                }

                if ("Notification" in window) {
                  Notification.requestPermission().then((permission) => {
                    if (permission === "granted") {
                      var notificationBrowser = new Notification(
                        "CCAAS-Worktual",
                        {
                          body: `Chat From ${message.contactDetails?.firstName !== ""
                            ? message.contactDetails?.firstName
                            : message.sender["Phone Number"]
                            } in worktual contact center`,
                          icon: "",
                        }
                      );
                      notificationBrowser.onclick = function (event) {
                        event.preventDefault();
                        window.parent.focus();
                        notificationBrowser.close();
                      };
                    }
                  });
                }
              });
          }
        } else {
          let declineData = {
            to: message?.userId.trim(),
            ext: userDetails?.ext,
            domainId: userDetails?.domainId,
            declined: true,
          };
          // callChatService.io.emit("queue_handling", declineData);
          dispatch(ChatActions?.setAdditionalChat(message));
        }
      } catch (error: any) {
        console.log("error is :", error);
      }
    });

    callChatService.io.on('ringingChatCloseEmitter', (data: any) => {
      try {
        const roomData: any = store.getState().chatReducer;
        if (roomData.isIncomingChat && roomData?.internalSessionDetailswhilePopup?.sessionId.trim() === data?.sessionId) {
          dispatch(ChatActions.declineChat());
          const ringer: any = document.getElementById("ringer");
          ringer.pause();
        }
      } catch (err) {
        console.log(err)
      }
    })


    // newEmail_entries ====>

    callChatService.io.on("newEmailIn", (message: any) => {
      dispatch(
        newEmailEntriesSliceActions.checkNewEmail({ isNewEmailEntry: true })
      );
    });

    // ====>

    callChatService.io.on("waitingQueueUpdate", (data: any) => {
      const parseData = data ? JSON.parse(data) : null;
      const campaign = store.getState().outboundcampaign;
      console.log("waitingQueueUpdate", parseData, "!campaign?.userCallInfo", !campaign?.userCallInfo)
      if (!campaign?.userCallInfo) {
        try {
          CallServices.get("/get_all_queue_wait_time").then((resp: any) => {
            dispatch(
              queueTrackerActions.queueTrackerData({
                queueTrackerData: resp.data.getAllQueueList,
              })
            );
          });
        } catch (error) {
          console.log("get_all_queue_wait_time error ", error)
        }

        dispatch(
          queueTrackerActions.updateQueueData({
            qid: parseData?.qid,
            queueList: parseData?.queueList,
            queueName: parseData?.queueName,

          })
        );
        getTime(dispatch)
      }


    });

    callChatService.io.on("send-message", (message: any) => {
      store.dispatch({
        type: Types.UPDATE_MESSAGE,
        payload: {
          messageList: message.msg,
        },
      });
    });

    callChatService.io.on("onMessageToCoChat", (message: any) => {
      store.dispatch(
        cochatDetailsActions.sendMessage({ message: message?.msg })
      );
    });
    callChatService.io.on("transferChatConnected", (message: any) => {
      dispatch(ChatActions.storeAgentTransfer(message));
    });

    callChatService.io.on("agentconnected", (message: any) => { });
    callChatService.io.on("notification", async (payload: any) => {
      new Notification("CCAAS-Worktual", {
        body: `${payload.message}`,
        icon: "",
      });
    });

    callChatService.io.on("messageHistory", (message: any) => {
      store.dispatch({
        type: Types.STORE_MESSAGE,
        payload: {
          messageList: message,
        },
      });
    });
    callChatService.io.on("outboundcallSession", (message: any) => {
      let { queueName, queueDetails }: any = store.getState().callPopUpDetails;
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      let callback = sessionStorage.getItem("callback");
      let callbackchat = sessionStorage.getItem("callbackchat");
      let voicemailUrl = sessionStorage.getItem("voicemailUrl");
      let callbackWhatsapp = sessionStorage.getItem("callbackWhatsapp");
      dispatch(CallPopUpAgentActions.setSessionId(message?.session_id.trim()));
      dispatch(CallPopUpAgentActions.setNumber(message.ddi)); // need clarification
      dispatch(CallPopUpAgentActions.setInitialTime());
      dispatch(CallPopUpAgentActions.cleartimer());
      if (callback && callback === "1") {
        sessionStorage.setItem("callback", message.session_id);
      }
      if (callbackchat && callbackchat === "1") {
        sessionStorage.setItem("callbackchat", message.session_id);
      }
      if (callbackWhatsapp && callbackWhatsapp === "1") {
        sessionStorage.setItem("callbackWhatsapp", message.session_id);
      }
      console.log(message, "outbound Session");
      //currentChatSession
      //chatSessionList
      if (message?.device_type === "CCAAS:BROWSER" && message?.pd === 0) {

        callChatService.io.emit("init_transfer", {
          session_id: message?.session_id,
          qid: `${queueDetails?.key ?? ''}`,
          req_type: 'EXTERNAL_QUEUE',
          OutboundCallerId: queueDetails?.OutboundCallerId ?? '',
          outBoundNumber: queueDetails?.outBoundNumber ?? ''
        });
        dispatch(ChatActions.setCallSessionId(message?.session_id ?? ""));
        console.log("chatSessionData?.sessionId", message?.session_id)


        dispatch(
          getNecessaryDetailswithsession({
            contact: message.ddi,
            sessionId: message.session_id,
          })
        )
          .unwrap()
          .then((res: any) => {
            if (res?.sessionDetail?.data.statusCode === 200) {
              let chatSessionData: any = res?.sessionDetail?.data?.result[0];
              chatSessionData.Number =
                chatSessionData?.callType === "outbound"
                  ? chatSessionData?.calledNumber
                  : chatSessionData?.customerDetails;
              // chatSessionData.calledPersonDetails = callSessionDetailswhilePopup.contactDetails;
              // chatSessionData.calledPersonDetails.tags = JSON.parse(callSessionDetailswhilePopup.contactDetails?.tags?.trim().length > 0 ? callSessionDetailswhilePopup.contactDetails?.tags : "null") ?? [];
              chatSessionData.showState = true;
              chatSessionData.queueName = queueName ?? "Default Queue";
              chatSessionData.outboundFromNumber = queueDetails?.outBoundNumber ?? "0";
              chatSessionData.queueId = queueDetails?.key;
              if (res?.contact?.data?.statusCode === 200) {
                chatSessionData.calledPersonDetails =
                  // res.contact?.data?.getContactNumberRes[0];
                  res.contact?.data?.getContactDetailsRes?.[0]|| res.contact?.data?.getContactNumberRes?.[0] 
                chatSessionData.calledPersonDetails.tags =
                  typeof res?.contact?.data?.getContactNumberRes[0]?.tags ===
                    "string"
                    ? JSON.parse(
                      res?.contact?.data?.getContactNumberRes[0]?.tags?.trim()
                        .length > 0
                        ? res?.contact?.data?.getContactNumberRes[0]?.tags
                        : "null"
                    ) ?? []
                    : res?.contact?.data?.getContactNumberRes[0]?.tags;
                // JSON.parse(res?.contact?.data?.getContactNumberRes[0]?.tags?.trim().length > 0 ? res?.contact?.data?.getContactNumberRes[0]?.tags : "null") ?? [];
              } else {
                chatSessionData.calledPersonDetails = {};
              }
              dispatch(
                updateContactinSession({
                  sessionId: chatSessionData.sessionId,
                  calledPersonDetails: chatSessionData.calledPersonDetails,
                })
              );
              if (voicemailUrl != null) {
                const Voicemail = {
                  domainId: loginUserCcaasDetail?.domainId,
                  ext: loginUserCcaasDetail?.ext,
                  to: message?.session_id,
                  sessionId: message?.session_id,

                  message: {
                    messageID: uuidv4(),
                    from: message?.session_id,
                    to: `${LoginCcaasUserDetails?.domainId}_${LoginCcaasUserDetails?.ext}`,
                    sessionId: message?.session_id,
                    message: JSON.parse(voicemailUrl),
                    sendAt: Math.floor(Date.now() / 1000),
                    messageType: "audio",
                    isVoicemail: true,
                    pdfurl: null,
                    isBot: false,
                    isCustomer: true,
                    sender: {
                      "Full Name": chatSessionData?.calledPersonDetails?.firstName + ' ' + chatSessionData?.calledPersonDetails?.lastName,
                      Email: chatSessionData?.calledPersonDetails?.email === "" ? "" : JSON.parse(chatSessionData?.calledPersonDetails?.email ?? 'null'),
                      "Phone Number": message?.ddi
                    }
                  }
                };
                dispatch(ChatActions.agentWorkSpaceTansferHistory(Voicemail?.message))
                callChatService.callVoiceMail(Voicemail)
                sessionStorage.removeItem("voicemailUrl");
              }
              sessionStorage.setItem('currentSec', JSON.stringify(chatSessionData))
              sessionStorage.setItem('currentSecId', JSON.stringify(chatSessionData?.sessionId))
              dispatch(ChatActions.chatSessionList(chatSessionData));
              dispatch(ChatActions.currentChatSession(chatSessionData));
              if (!callback) {
                navigate("/chatscreenagent");
              }
            }
          });
      }
    });
    callChatService.io.on("callMergeedSuccess", async (message: any) => {
      let userData: any = jwt_decode(token);
      let setuserAgent = message.Agent;
      let AgentWhole: any = [];
      let customerContactDetails: any;
      const { incomingcallDetails } = store.getState().chatReducer;

      let { TransferFrom, transferTo }: any = store.getState().callPopUpDetails;
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      const isValidAgent = message.agentInfo?.some((agent: any) => {
        console.log("callMergeedSuccess", "isValidAgent", userDetails?.ext.toString() === agent?.ext.toString(), agent?.ext.toString(), userDetails?.ext.toString())
        return (

          userDetails?.ext.toString() === agent?.ext.toString() && agent?.device_type === "CCAAS:BROWSER");
      });
      console.log(isValidAgent, "isValidAgent")
      if (isValidAgent) {

        if (+(message?.Agent[message?.Agent.length - 1]) === loginUserCcaasDetail?.ext) {
          let details: any = await showDetials({ sessionId: message?.session_id.trim(), channelType: "Call" })
          if (details?.data?.statusCode === 200) {
            const message_1 = JSON.parse(details?.data?.getEmailListRes[0]?.Message ?? '[]')
            dispatch(ChatActions.agentViewWorkSpaceHistory_WB(Array.isArray(message_1) ? message_1 : []));
          }
        }
        await dispatch(
          getNecessaryDetailswithsession({
            contact: message.customer,
            sessionId: message.session_id,
          })
        )

          .unwrap()
          .then((Res: any) => {
            if (Res?.contact?.data?.statusCode === 200) {
              customerContactDetails = Res?.contact.data?.getContactNumberRes[0] || Res.contact?.data?.getContactDetailsRes?.[0];

              if (Res.sessionDetail.data.statusCode === 200) {
                let chatSessionData: any = Res.sessionDetail.data.result[0];
                chatSessionData.Number = chatSessionData.customerDetails;
                chatSessionData.showState = true;
                chatSessionData.queueId = incomingcallDetails?.qid;
                // getContactDetailsWhilegettingCall(chatSessionData.Number).then((res: any) => {
                //   if (res?.data?.statusCode === 200) {
                chatSessionData.calledPersonDetails = customerContactDetails;
                chatSessionData.calledPersonDetails.tags =
                  typeof customerContactDetails?.tags === "string"
                    ? JSON.parse(
                      customerContactDetails?.tags?.trim().length > 0
                        ? customerContactDetails?.tags
                        : "null"
                    ) ?? []
                    : customerContactDetails?.tags;

                    if(message?.Agent?.[0] !== userDetails?.ext?.toString()){
                      try {
                        const coid = Res.contact?.data?.getContactNumberRes?.[0]?.coid || Res.contact?.data?.getContactDetailsRes?.[0]?.coid
                        getPriviousChannelSummary(dispatch, { coid, currentSessionId: message.session_id?.trim() })
                      } catch (error) {
                        console.log("getPriviousChannelSummary", error)
                      }
                    }
                dispatch(ChatActions.chatSessionList(chatSessionData));
                dispatch(ChatActions.currentChatSession(chatSessionData));
                dispatch(ChatActions.setCallSessionId(chatSessionData?.sessionId ?? ""));
                dispatch(CallPopUpAgentActions.setTransferTyper());
                console.log(" TransferFrom customerMsg?.length > 0 merge", TransferFrom?.transferDataDetails, "TransferFrom?.transferDataDetails)", TransferFrom)
                const merge = { ...TransferFrom?.transferDataDetails, message: `Merge call from ${TransferFrom?.fromExt}` }
                dispatch(ChatActions.agentWorkSpaceTansferHistory(merge));
                dispatch(CallPopUpAgentActions.setTransferFrom([]))
                //navigate("/chatscreenagent");
                // });
              }


              let customerData = {
                from: message.customer,
                contactDetails: customerContactDetails,
                to: message.Agent[0],
                muteState: false,
                holdState: false,
                medium: false,
                bound: "IN",
                agentType: "CUSTOMER",
                isCustomer: true,
                isLogin: false,
                isPrimary: message.Agent[0],
              };
              AgentWhole[0] = customerData;

              let primaryAgentDetail: any = {
                from: message.customer,
                to: message.Agent[0],
                contactDetails: getUser(message.Agent[0]) ?? {},
                muteState: false,
                holdState: false,
                medium: false,
                bound: "IN",
                agentType: "PRIMARY",
                isPrimary: message.Agent[0],
                isCustomer: false,
                isLogin:
                  userData.ext.toString() === message.Agent[0] ? true : false,
              };

              AgentWhole.push(primaryAgentDetail);
              let SecondaryAgentDetails: any = [];
              let seccondary: any;

              seccondary = message.Agent.filter((agent: any) => {
                return agent !== primaryAgentDetail.to;
              });

              seccondary.map((item: any) => {
                let contacts = {
                  from: primaryAgentDetail.to,
                  to: item,
                  contactDetails: getUser(item) ?? {},
                  muteState: false,
                  holdState: false,
                  medium: false,
                  bound: "OUT",
                  agentType: "SECONDARY",
                  isCustomer: false,
                  isPrimary: message.Agent[0],
                  isLogin: userData.ext.toString() === item ? true : false,
                };
                SecondaryAgentDetails.push(contacts);
                AgentWhole.push(contacts);
              });

              let mergeData: any = {
                customer: customerData,
                primaryAgent: primaryAgentDetail,
                SecondaryAgent: SecondaryAgentDetails,
                AgentDetails: AgentWhole,
                AllAgent: setuserAgent,
                userData: userData,
              };

              dispatch(CallPopUpAgentActions.mergeCallDataSetUp(mergeData));
            }
            navigate("/chatscreenagent");
          });

        // getContactDetailsWhilegettingCall(message.customer).then((res: any) => {
        //   if (res?.data?.statusCode === 200) {
        //     customerContactDetails = res?.data?.getContactNumberRes[0];

        //     let customerData = {
        //       from: message.customer,
        //       contactDetails: customerContactDetails,
        //       to: message.Agent[0],
        //       muteState: false,
        //       holdState: false,
        //       medium: false,
        //       bound: "IN",
        //       agentType: "CUSTOMER",
        //       isCustomer: true,
        //       isLogin: false,
        //       isPrimary: false,
        //     };
        //     AgentWhole[0] = customerData;

        //     let primaryAgentDetail: any = {
        //       from: message.customer,
        //       to: message.Agent[0],
        //       contactDetails: getUser(message.Agent[0]) ?? {},
        //       muteState: false,
        //       holdState: false,
        //       medium: false,
        //       bound: "IN",
        //       agentType: "PRIMARY",
        //       isPrimary: true,
        //       isCustomer: false,
        //       isLogin: userData.ext.toString() === message.Agent[0] ? true : false,
        //     };

        //     AgentWhole.push(primaryAgentDetail);
        //     let SecondaryAgentDetails: any = [];
        //     let seccondary: any;

        //     seccondary = message.Agent.filter((agent: any) => {
        //       return agent !== primaryAgentDetail.to;
        //     });

        //     seccondary.map((item: any) => {
        //       let contacts = {
        //         from: primaryAgentDetail.to,
        //         to: item,
        //         contactDetails: getUser(item) ?? {},
        //         muteState: false,
        //         holdState: false,
        //         medium: false,
        //         bound: "OUT",
        //         agentType: "SECONDARY",
        //         isCustomer: false,
        //         isPrimary: false,
        //         isLogin: userData.ext.toString() === item ? true : false,
        //       };
        //       SecondaryAgentDetails.push(contacts);
        //       AgentWhole.push(contacts);
        //     });

        //     let mergeData: any = {
        //       customer: customerData,
        //       primaryAgent: primaryAgentDetail,
        //       SecondaryAgent: SecondaryAgentDetails,
        //       AgentDetails: AgentWhole,
        //       AllAgent: setuserAgent,
        //       userData: userData
        //     };

        //     dispatch(CallPopUpAgentActions.mergeCallDataSetUp(mergeData));
        //   }
        //   console.log(window.location.pathname !== "/chatscreenagent","window.location.pathname ");
        //   ApiServices.get(CALLURL, `/get_chatSessionId/${message.session_id}`).then((response: any) => {
        //     if (response.data.statusCode === 200) {
        //       let chatSessionData: any = response.data.result[0];
        //       chatSessionData.Number = chatSessionData.customerDetails;
        //       chatSessionData.showState = true;
        //       getContactDetailsWhilegettingCall(chatSessionData.Number).then((res: any) => {
        //         if (res?.data?.statusCode === 200) {
        //           chatSessionData.calledPersonDetails = res?.data?.getContactNumberRes[0];
        //           chatSessionData.calledPersonDetails.tags =
        //             typeof res?.data?.getContactNumberRes[0]?.tags === "string"
        //               ? JSON.parse(res?.data?.getContactNumberRes[0]?.tags?.trim().length > 0 ? res?.data?.getContactNumberRes[0]?.tags : "null") ?? []
        //               : res?.data?.getContactNumberRes[0]?.tags;
        //           // chatSessionData.calledPersonDetails.tags = JSON.parse(res?.data?.getContactNumberRes[0]?.tags) ?? [];
        //         } else {
        //           chatSessionData.calledPersonDetails = {};
        //         }
        //         dispatch(ChatActions.chatSessionList(chatSessionData));
        //         dispatch(ChatActions.currentChatSession(chatSessionData));
        //         dispatch(CallPopUpAgentActions.setTransferTyper());
        //         //navigate("/chatscreenagent");
        //       });
        //     }
        //     navigate("/chatscreenagent");
        //   });

        // if (window.location.pathname !== "/chatscreenagent") {
        //   navigate("/chatscreenagent");
        // }
        // });
      }
    });

    callChatService.io.on("callTransferedSuccess", async (message: any) => {
      const { answeredDuration, incomingcallDetails } = store.getState().chatReducer;
      const userDetails1 = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      let { TransferFrom, transferTo }: any = store.getState().callPopUpDetails;
      if (message?.deviceType === "CCAAS:BROWSER" && message?.transferType === 1) {
        await ApiServices.get(
          CALLURL,
          `/get_callSessionId/${message.session_id}`
        ).then(async (response: any) => {
          if (response.data.statusCode === 200) {
            let chatSessionData: any = response.data.result[0];
            console.log("chatSessionData", chatSessionData);

            let details: any = await showDetials({ sessionId: message?.session_id.trim(), channelType: "Call" })
            if (details?.data?.statusCode === 200) {
              const message_1 = JSON.parse(details?.data?.getEmailListRes[0]?.Message ?? '[]')
              console.log("message_1>>>>>>", message_1)
              dispatch(ChatActions.agentViewWorkSpaceHistory_WB(Array.isArray(message_1) ? message_1 : []));
            }
            chatSessionData.Number = chatSessionData.customerNumber;
            chatSessionData.showState = true;

            getContactDetails(chatSessionData.Number, "Call").then(
              (res: any) => {
                if (res?.data?.statusCode === 200) {
                  chatSessionData.calledPersonDetails =
                    res?.data?.getContactNumberRes[0];
                  chatSessionData.calledPersonDetails.tags =
                    typeof res?.data?.getContactNumberRes[0]?.tags === "string"
                      ? JSON.parse(
                        res?.data?.getContactNumberRes[0]?.tags?.trim()
                          .length > 0
                          ? res?.data?.getContactNumberRes[0]?.tags
                          : "null"
                      ) ?? []
                      : res?.data?.getContactNumberRes[0]?.tags;
                  chatSessionData.queueId = incomingcallDetails?.qid;
                  chatSessionData.queueName = incomingcallDetails?.queueName ?? null;
                  try {
                    const coid = res?.data?.getContactNumberRes?.[0]?.coid
                    getPriviousChannelSummary(dispatch, { coid, currentSessionId: message?.session_id.trim() })
                  } catch (error) {
                    console.log("getPriviousChannelSummary error", error)
                  }
                  // chatSessionData.calledPersonDetails.tags = JSON.parse(res?.data?.getContactNumberRes[0]?.tags) ?? [];
                } else {
                  chatSessionData.calledPersonDetails = {};
                }
                dispatch(CallPopUpAgentActions.setCallingval(false));
                dispatch(ChatActions.chatSessionList(chatSessionData));
                dispatch(ChatActions.currentChatSession(chatSessionData));
                dispatch(CallPopUpAgentActions.setTransferTyper());
                console.log(" TransferFrom customerMsg?.length > 0", TransferFrom?.transferDataDetails, "TransferFrom?.transferDataDetails)", TransferFrom)
                const merge = { ...TransferFrom?.transferDataDetails, message: `Transfer call from ${TransferFrom?.fromExt}` }

                dispatch(ChatActions.agentWorkSpaceTansferHistory(merge));
                dispatch(CallPopUpAgentActions.setTransferFrom([]))
                const body: any = {
                  CallHistoryId: chatSessionData?.CallHistoryId,
                  domainId: userDetails?.domainId,
                  AgentId: userDetails1?.UserID,
                  answeredDuration: answeredDuration ?? 0,
                }
                callChatService.callNotifyDialDuration(body);
                navigate("/chatscreenagent");

              }
            );
          }
          navigate("/chatscreenagent");
        });
      }
    });

    callChatService.io.on("callTransferEvent", (message: any) => {
      dispatch(CallPopUpAgentActions.setTransferTyper());
      navigate("/chatscreenagent");
    });

    callChatService.io.on("leave_call", (message: any) => {
      let userData: any = jwt_decode(token);
      if (message.endBy !== userData.ext) {
        console.log("MESSAGE DISCONNECTED BY", message);
        dispatch(CallPopUpAgentActions.leaveCallDataSetUp({ ...message, userExt: userData.ext }));
      }
    });
    callChatService.io.on("callLiveDashboard", (message: any) => {
      if (["/dynamicdashboard", "/agentdashboard", "/agentdashboardstandalone", "/standaloneDashboard"].includes(window.location.pathname)) {
        getDashboardCallDatalive(dispatch);
      }
    });
    callChatService.io.on("emailLiveDashboard", (message: any) => {
      getDashboardEmailDatalive(dispatch);
    });
    callChatService.io.on("smsLiveDashboard", (message: any) => {
      getDashboardSmsDatalive(dispatch);
    });
    callChatService.io.on("socialMediaLiveDashboard", (message: any) => {
      getDashboardSocialmediaDatalive(dispatch);
    });

    callChatService.io.on("leave_call_by_secondary", (message: any) => {
      let userData: any = jwt_decode(token);

      if (message.endBy !== userData.ext) {
        message["userData"] = userData;
        console.log("MESSAGE DISCONNECTED BY", message);
        dispatch(CallPopUpAgentActions.leaveCallSecondaryAgent(message));
      }
    });

    callChatService.io.on("recievemessage", (message: any) => {
      let { messageList, currentSession, sessionList }: any =
        store.getState().chatReducer;

      if (currentSession.sessionId === message?.message?.sessionId) {
        let updatedCurrentSession: any = currentSession;
        updatedCurrentSession.lastMessage = message.message.message;
        store.dispatch({
          type: Types.CURRENT_CHAT_SESSION,
          payload: {
            currentSession: updatedCurrentSession,
          },
        });
        callChatService.io.emit("deliveryStatus", {
          id: message.message.id,
          room: message.message.room,
          from: "agent",
        });
        callChatService.io.emit("readStatus", {
          id: message.message.id,
          room: message.message.room,
          from: "agent",
        });
        let newMessageArray: any = [...messageList, message.message];

        store.dispatch({
          type: Types.STORE_MESSAGE,
          payload: {
            messageList: newMessageArray,
          },
        });
      } else {
        let sessionIndex: any = sessionList.findIndex(
          (data: any) => data.sessionId === message?.message?.sessionId
        );
        let sessionData: any = sessionList[sessionIndex];
        sessionData.lastMessage = message.message.message;
        sessionData.unreadCount = sessionData?.unreadCount
          ? sessionData?.unreadCount + 1
          : 1;

        callChatService.io.emit("deliveryStatus", {
          id: message.message.id,
          room: message.message.room,
          from: "agent",
        });
      }
    });

    callChatService.io.on('incomingcall_queue_name', (data: any) => {
      console.log("incomingcall_queue_name", data)
      dispatch(ChatActions.incomingcallDetails(data))
      const campaign = store.getState().outboundcampaign;
      if (Object.keys(campaign?.incomingCallInfo ?? {}).length === 0) {
        dispatch(outboundCampaignSliceAction.setincomingCallInfo(data))
      }

      callChatService.callDashboard(data?.domain_id)
    })


    callChatService.io.on("updatedstatus", (data: any) => {
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      if (
        userDetails?.ext?.toString() === data?.ext?.toString() &&
        userDetails?.domainId?.toString() === data?.domainId?.toString()
      ) {
        dispatch(
          AgentStateAction.setCurrentStatus({ status: data?.statusName })
        );
      }
    });

    callChatService?.io?.on("userStatusBackendTransfer", (data: any) => {
      if (data) {
        presenceService?.io?.emit("updatestate_backend", data);
        callChatService.io.emit("agent_ready_for_queue_users", data);
      }
    });

    callChatService.io.on("updatedstatuslist", (data: any) => {
      dispatch(agentstatusListAction.pushagentlist(data));
    });

    callChatService.io.on("callQueueWait", (data: any) => {
      let userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      if (parseInt(data?.domainId) === parseInt(userDetails?.domainId)) {
        CallServices.get("/get_all_queue_wait_time").then((resp: any) => {
          dispatch(
            queueTrackerActions.queueTrackerData({
              queueTrackerData: resp.data.getAllQueueList,
            })
          );
        });
      }
    });

    callChatService.io.on("userStatusUpdated", (data: any) => {
      let userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      if (data?.email && data?.status) {
        let setData = {
          email: data?.email ?? "",
          status: data?.status ?? "Offline",
        };
        dispatch(agentTrackerActions.updateUserInAgentTracker(setData));
        dispatch(GetAlluserActions.updateStatus(setData));
      }

      if (parseInt(userDetails?.domainId) === parseInt(data?.domainId) && !DOMAINID.includes(data?.domainId)) {
        CallServices.get("/get_all_queue_wait_time").then((resp: any) => {
          dispatch(
            queueTrackerActions.queueTrackerData({
              queueTrackerData: resp.data.getAllQueueList,
            })
          );
        });

        CoreServices.get(`/get_all_user_list`).then((resp: any) => {
          let dataValue: any = "";
          const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
          if (userRoleId != ROLES.AGENT_ROLE_ID) {
            dataValue = resp.data.getAllUserList;
            let result = MapAgentTrackerData(dataValue, userRoleId?.toString());
            dispatch(
              agentTrackerActions.updateAgentTrackerData({
                agentTrackerData: result,
              })
            );
          }
          dispatch(
            agentTrackerActions.updateAgentList({
              agentList: resp.data.getAllUserList,
            })
          );
        });
        dispatch(getAllUsers());
      }
    });

    callChatService.io.on("callback", (eventInfo: any) => {
      if (eventInfo.req_type === "CALLBACK") {
        let data: any = {
          isCallBackWaiting: true,
          callBackDetails: eventInfo,
          callBackTimer: 30,
          reject: false,
        };
        dispatch(CallPopUpAgentActions.setCallBackInfo(data));
        callBackTimerFunc(eventInfo.callbackDid);
        const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        const LoginUserDetails: any = userDetails;
        const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
        const { users } = store.getState().userList;
        let enableStatus: any = null
        if (users.length > 0) {
          [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
        }
        console.log('presenceService 16');
        presenceService?.io?.emit("updatestate_backend", {
          domainId: LoginUserDetails?.domainId,
          isVoice: 0,
          isVoiceCallTransfer: 0,
          isChat: 0,
          isChatTransfer: 0,
          isEmail: 0,
          isEmailTransfer: 0,
          stateTime: Math.floor(Date.now() / 1000),
          statusName: 'Busy',
          ext: LoginUserDetails?.ext,
          email: LoginUserDetails?.Email,
          userId: LoginUserDetails?.UserID,
          routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
          userName: LoginCcaasUserDetails?.UserName,
          roleId: LoginCcaasUserDetails?.roleid,
          agentStatus: 0,
          skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
          routingMethod: enableStatus?.routingMethod ?? 0,
          inboundCall: enableStatus?.inboundCall,
          outboundCampaignCall: enableStatus?.outboundCampaignCall,
          is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
        });
      }
    });

    callChatService.io.on("callback_update", (info: any) => {
      console.log("callback_update>>>>>>", info)
      if (info.device_type != "CCAAS:BROWSER") {
        let data = {
          isCallBackWaiting: false,
          callBackDetails: {},
          callBackTimer: 30,
          reject: false
        };
        dispatch(CallPopUpAgentActions.setCallBackInfo(data));
      }

    })

    // callChatService.io.on("agentConnect", (message: any) => {
    //   let ringer: any = document.getElementById("ringer");

    //   if (ringer) {
    //     if (document.hasFocus()) {
    //       ringer?.play();
    //       ringer.muted = false;
    //     } else {
    //       const ans = window.confirm("Do you want to enable chat ringtone?");
    //       if (ans) {
    //         ringer?.play();
    //         ringer.muted = false;
    //       }
    //     }
    //   }
    //   store.dispatch({
    //     type: Types.POPUP_MESSAGE,
    //     payload: {
    //       acceptRoom: true,
    //       roomInfo: message?.roomname,
    //       sessionId: message?.sessionId,
    //       sessionDetailswhilePopup: message?.sessionDetails,
    //     },
    //   });
    // });

    callChatService.io.on("agent_state", (message: any) => { });

    callChatService.io.on("receivedEmail", (message: any, data: any) => {
      dispatch(
        ChatActions.setChatSessionList({
          ...message,
          ChatHistoryId: "",
          calledPersonDetails:
            message?.calledPersonDetails !== null &&
              Object.keys(message?.calledPersonDetails).length > 0
              ? message?.calledPersonDetails
              : null,
        })
      );
      dispatch(ChatActions.setUnreadMessageCount(message));
      if (message?.agentAssist !== undefined && message?.agentAssist) {
        dispatch(ChatActions.setAssistPayload({ channel: "Email", sessionId: message?.sessionId, channelId: message?.ToEmail }));
        dispatch(ChatActions.chatAgentAssistReload(true));
      }
    });

    callChatService.io.on("receivedSms", (message: any, data: any) => {
      dispatch(
        ChatActions.setChatSessionList({
          ...message,
          ChatHistoryId: "",
          calledPersonDetails:
            message?.calledPersonDetails !== null &&
              Object.keys(message?.calledPersonDetails).length > 0
              ? message?.calledPersonDetails
              : null,
        })
      );
      dispatch(ChatActions.setUnreadMessageCount(message));
      if (message?.agentAssist !== undefined && message?.agentAssist) {
        dispatch(ChatActions.setAssistPayload({ channel: "Sms", sessionId: message?.sessionId, channelId: message?.calledNumber }));
        dispatch(ChatActions.chatAgentAssistReload(true));
      }
    });

    callChatService.io.on("receivedWhatsapp", (message: any, data: any) => {
      dispatch(
        ChatActions.setChatSessionList({
          ...message,
          ChatHistoryId: "",
          calledPersonDetails:
            message?.calledPersonDetails !== null &&
              Object.keys(message?.calledPersonDetails)?.length > 0
              ? message?.calledPersonDetails
              : null,
        })
      );
      dispatch(ChatActions.setUnreadMessageCount(message));
      if (message?.agentAssist !== undefined && message?.agentAssist) {
        dispatch(ChatActions.setAssistPayload({ channel: "Whatsapp", sessionId: message?.sessionId, channelId: message?.calledNumber }));
        dispatch(ChatActions.chatAgentAssistReload(true));
      }
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_socialmedia({...message }, dispatch)
      }
    });

    callChatService.io.on("receivedFacebook", (message: any, data: any) => {
      dispatch(
        ChatActions.setChatSessionList({
          ...message,
          ChatHistoryId: "",
          calledPersonDetails:
            message?.calledPersonDetails !== null &&
              Object.keys(message?.calledPersonDetails)?.length > 0
              ? message?.calledPersonDetails
              : null,
        })
      );
      dispatch(ChatActions.setUnreadMessageCount(message));
      if (message?.agentAssist !== undefined && message?.agentAssist) {
        dispatch(ChatActions.setAssistPayload({ channel: "Facebook", sessionId: message?.sessionId, channelId: message?.agentFacebookId }));
        dispatch(ChatActions.chatAgentAssistReload(true));
      }
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_socialmedia({...message }, dispatch)
      }
    });

    callChatService.io.on("receivedInstagram", (message: any, data: any) => {
      dispatch(
        ChatActions.setChatSessionList({
          ...message,
          ChatHistoryId: "",
          calledPersonDetails:
            message?.calledPersonDetails !== null &&
              Object.keys(message?.calledPersonDetails)?.length > 0
              ? message?.calledPersonDetails
              : null,
        })
      );
      dispatch(ChatActions.setUnreadMessageCount(message));
      if (message?.agentAssist !== undefined && message?.agentAssist) {
        dispatch(ChatActions.setAssistPayload({ channel: "Instagram", sessionId: message?.sessionId, channelId: message?.agentInstagramId }));
        dispatch(ChatActions.chatAgentAssistReload(true));
      }
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_socialmedia({...message }, dispatch)
      }    
    });
    callChatService.io.on("supervisiorActivity", () => {
      dispatch(allActivityActions.setSuperVisorVal());
      dispatch(ChatActions.setActivityAutoRefresh());
      callChatService.emailDashboard(loginUserCcaasDetail?.domainId);
      callChatService.smsDashboard(loginUserCcaasDetail?.domainId);
      callChatService.socialmediaDashboard(loginUserCcaasDetail?.domainId);
      dispatch(setCallNotification(true));

    });
    callChatService.io.on("chatCallbackEmitter", () => {
      if (loginUserCcaasDetail?.roleid != '6') {
        dispatch(allActivityActions.setSuperVisorVal());
        dispatch(ChatActions.setActivityAutoRefresh());
        dispatch(ChatActions.setDashCallBackRefresh());
      }
    });
    callChatService.io.on("adminActivity", () => {
      dispatch(allActivityActions.setSuperVisorVal());
      dispatch(ChatActions.setActivityAutoRefresh());
      callChatService.emailDashboard(loginUserCcaasDetail?.domainId)
      callChatService.smsDashboard(loginUserCcaasDetail?.domainId)
      callChatService.socialmediaDashboard(loginUserCcaasDetail?.domainId)
    });
    callChatService.io.on("interActionClosed", () => {
      dispatch(ChatActions.setActivityAutoRefresh());
      dispatch(ChatActions.setAllViewAutoRefresh());
    });
    callChatService.io.on("interActionScreenClosed", (data: any) => {
      console.log('<<<<interActionScreenClosed>>>>', data)
      if (data?.sessionId) {
        dispatch(ChatActions.sessionRemoveAfterEnd(data.sessionId));
      }
    });
    callChatService.io.on("assignActivityListener", (data: any) => {
      if (data?.data?.req_type) {
        if (loginUserCcaasDetail?.roleid != "6") {
          dispatch(allActivityActions.setSuperVisorVal());
          dispatch(ChatActions.setActivityAutoRefresh());
          dispatch(ChatActions.setActivityAutoRefresh());
          dispatch(setCallNotification(true));
          dispatch(ChatActions.setDashCallBackRefresh());
        }
      } else {
        dispatch(allActivityActions.setSuperVisorVal());
        dispatch(ChatActions.setActivityAutoRefresh());
      }
    });
    callChatService.io.on("reAssignActivityListener", (data: any) => {
      dispatch(allActivityActions.setReAssignCount());
      dispatch(ChatActions.setActivityAutoRefresh());
      dispatch(setCallNotification(true));
    });

    callChatService.io.on("supervisiorActivityBot", (data: any) => {
      dispatch(ChatActions.setAllViewAutoRefresh());
    });
    callChatService.io.on("adminActivityBot", (data: any) => {
      dispatch(ChatActions.setAllViewAutoRefresh());
    });

    callChatService.io.on("ai_dashboard_response", (data: any) => {
      let payload = {
        ...data,
        isUser: 0,
        sendAt: Date.now(),
      }
      dispatch(DynamicDashboardSliceActions.setAiChatDashboardMsg(payload));
    });

    callChatService.io.on("ai_chat_response", (data: any) => {
      let payload = {
        ...data,
        isUser: 0,
        sendAt: Date.now(),
      }
      dispatch(DynamicDashboardSliceActions.setAiChatMsg(payload));
    });


    callChatService.io.on("agentAssistOmniChannel", (data: any) => {
      if (data) {
        if (data.timeStamp === undefined || data.timeStamp === null) {
          data.timeStamp = new Date().getTime();
        }

        const assistentData: any = store.getState().chatReducer?.agentAssitence;
        const lastMsg = assistentData?.[assistentData.length - 1]?.message ?? '';
        if (lastMsg !== data?.message) {
          // dispatch(ChatActions.agaentAssitence(data));
        }
        dispatch(ChatActions.agaentAssitence(data));
        const body = {
          AssistMsg: {
            assistMsg: data.message,
            isLike: 0,
            isDislike: 0,
            isUsed: 0
          },
          NoOfUsedAssistMsg: 0,
          totalNoOfassist: 1,
        };
        insertUpdateAgentAssist(body);
      }
    });

    callChatService.io.on("liveTrackingReport", (data: any) => {
      data["timeStamp"] = new Date().getTime();
      dispatch(LiveTrackerActions.setLiveTrackerList(data));
    });

    callChatService.io.on("agentNotAttendEmitter", (data: any) => {
      console.log(data)
    });

    callChatService.io.on("customerContactEmitter", (data: any) => {
      dispatch(supervisorContactDataSliceActions.setContactRefresh());
      if (loginUserCcaasDetail?.roleid == ROLES?.ADMIN_ROLE_ID || loginUserCcaasDetail?.roleid == ROLES?.SUPERVISOR_ROLE_ID) {
        getLiveSessions(dispatch);
      }
      if (data) {
        dispatch(ChatActions.update_called_person_details(data));
      }
    });
    callChatService.io.on("sendInvite", (data: any) => {

      let ringer: any = document.getElementById("ringer");
      if (ringer) {
        ringer?.play();
        ringer.muted = false;
        // if (document.hasFocus()) {

        //   ringer?.play();
        //   ringer.muted = false;
        // } else {

        //   const ans = window.confirm(
        //     "Do you want to enable chat ringtone?"
        //   );
        //   if (ans) {
        //     ringer?.play();
        //     ringer.muted = false;
        //   }
        // }
      }

      dispatch(SocialmediaWidgetActions.setSocialmediaInvite(true));
      dispatch(SocialmediaWidgetActions.setInviteData({ ...data }));
    });
    callChatService.io.on("deleteUserLogout", (data: any) => {
      localStorage.clear();
      sessionStorage.clear();
      Cookie.clear();
      navigate("/");
      ClearStorage();
    })

    callChatService.io.on("allviewsRefresh", (data: any) => {
      dispatch(ChatActions.setAllViewAutoRefresh());
      if (!DOMAINID.includes(`${loginUserCcaasDetail?.domainId}`) && (loginUserCcaasDetail?.roleid == ROLES?.ADMIN_ROLE_ID || loginUserCcaasDetail?.roleid == ROLES?.SUPERVISOR_ROLE_ID)) {
        getLiveSessions(dispatch)
      }
    });
    callChatService.io.on("callTransferDetails", (data: any) => {
      dispatch(CallPopUpAgentActions.setTransferFrom(data));
    });

    callChatService.io.on("auto_answer", (data: any) => {
      dispatch(outboundCampaignSliceAction.setAutoAnswer(data?.isAutoAnswer));
    });

    callChatService.io.on("trigger_emitter", (data: any) => {
      const { liveSessions } = store.getState().agentTracker;

      // const updatedSessions = liveSessions?.map((session: any) => {
      //   if (session?.historyId === data?.ChatHistoryId && data?.isTrigger === 1) {
      //     return { ...session, isTrigger: 1 };
      //   }
      //   return session;
      // });

      const updatedSessions = liveSessions?.map((session: any) => {
        try {
          const isMatch = data.ChannelType === "Chat"
            ? session.historyId === data.HistoryId : data.ChannelType === "Whatsapp" ?
              session.durationHistoryId === data.durationHistoryId
              : session.historyId === data.durationHistoryId;
          if (isMatch && data.isTrigger === 1) {
            return { ...session, isTrigger: 1 };
          }
          return session;
        } catch (error) {
          console.log('trigger_emitter error', error)
        }
      });


      store.dispatch(agentTrackerActions.liveSessions(updatedSessions));
    });

    callChatService.io.on("internal_chat_msg_recevie", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      if (internalChatDetails?.internalChatGroupId === message?.internalChatGroupId) {
        const userDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
        const msg_status = {
          internalChatId: message?.internalChatId,
          domainId: message?.domainId,
          senderAgentId: userDetails?.UserID,
          msgStatus: 1,
          agentUserId: message?.agentUserId,
        };

        callChatService.io.emit("internal_chat_msg", { ...msg_status });
        dispatch(
          ChatActions.setInternalChatDetails({
            ...internalChatDetails,
            chatMessage: [
              ...internalChatDetails?.chatMessage,
              { ...message, msg: JSON.stringify(message?.msg) },
            ],
          })
        );
      } else {
        dispatch(
          ChatActions.setInternalChatDetails({
            ...internalChatDetails,
            reload: !internalChatDetails?.reload,
          })
        );
      }
    });
    callChatService.io.on("create_internal_chat", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      dispatch(
        ChatActions.setInternalChatDetails({
          ...internalChatDetails,
          chatMessage: [...internalChatDetails?.chatMessage],
          notification: [...internalChatDetails?.notification, message],
          reload: !internalChatDetails?.reload,
        })
      );
    });
    callChatService.io.on("update_internal_chat", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      dispatch(
        ChatActions.setInternalChatDetails({
          ...internalChatDetails,
          chatMessage: [...internalChatDetails?.chatMessage],
          notification: [...internalChatDetails?.notification, message],
          reload: !internalChatDetails?.reload,
        })
      );
    });
    callChatService.io.on("internal_chat_msg_status", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      if (internalChatDetails?.chatMessage?.length > 0) {
        const data: any = [...internalChatDetails?.chatMessage];

        for (let status of message?.readStatus) {
          const index = internalChatDetails?.chatMessage.findIndex((element: any) => element?.internalChatId == status?.internalChatId);

          if (index > -1) {
            if (data[index] !== undefined && message?.msgStatus !== undefined)
              data[index] = { ...data[index], isAllRead: status?.isAllRead };
            dispatch(
              ChatActions.setInternalChatDetails({
                ...internalChatDetails,
                chatDetails: { ...internalChatDetails?.chatDetails, isGroupClosed: status?.isGroupClosed, isAgentDeleted: status?.isAgentDeleted },
                chatMessage: [...data],
                reload: !internalChatDetails?.reload,
              })
            );
          }
        }
      }
    });
    callChatService.io.on("pstnleavecall", (message: any) => {
      // dispatch(CallPopUpAgentActions.removePstnCallerId(message));
      let userData: any = jwt_decode(token);
      if (message.participant_left !== userData.ext) {
        message["userData"] = userData;
        message['endBy'] = message.participant_left
        console.log("MESSAGE DISCONNECTED BY", message);
        dispatch(CallPopUpAgentActions.leaveCallSecondaryAgent(message));
      }
    })

    callChatService.io.on("force_logout", (data: any) => {
      try {
        const LoginUserDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
        if (LoginUserDetails?.domainId.toString() === data?.domainId.toString() && LoginUserDetails?.ext.toString() === data?.ext.toString()) {
          Cookie.clear();
          navigate("/login");
          ClearStorage();
          localStorage.clear();
          callChatService.destroy();
          sessionStorage.clear();
        }
      } catch (error) {
        console.log('force_logout >>>', error);
      }
    });

    callChatService.io.on("edit_internal_chat", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      if (internalChatDetails?.chatMessage?.length > 0) {
        const index = internalChatDetails?.chatMessage.findIndex(
          (element: any) => element?.internalChatId == message?.internalChatId
        );
        if (index > -1) {
          const data = [...internalChatDetails?.chatMessage];
          if (data[index] !== undefined && message?.msg !== undefined)
            data[index] = { ...data[index], msg: JSON.stringify(message?.msg) };
          dispatch(
            ChatActions.setInternalChatDetails({
              ...internalChatDetails,
              chatMessage: [...data],
              isEdit: false, editChat: {},
              reload: !internalChatDetails?.reload,
            })
          );
        }
      }
    });
    callChatService.io.on("delete_internal_chat", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      if (internalChatDetails?.chatMessage?.length > 0) {
        const index = internalChatDetails?.chatMessage.findIndex(
          (element: any) => element?.internalChatId == message?.internalChatId
        );
        if (index > -1) {
          const message = [...internalChatDetails?.chatMessage];
          message.splice(index, 1);
          dispatch(
            ChatActions.setInternalChatDetails({
              ...internalChatDetails,
              chatMessage: [...message],
              reload: !internalChatDetails?.reload,
            })
          );
        }
      }
    });
    callChatService.io.on("markAsRead_internal_chat", (message: any) => {
      let { internalChatDetails } = store.getState().chatReducer;
      dispatch(
        ChatActions.setInternalChatDetails({
          ...internalChatDetails,
          reload: !internalChatDetails?.reload,
        })
      );
    });

    callChatService.io.on("broadcast_message", (message: any) => {
      const rowData = store.getState()?.chatReducer?.rowData;
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      if (message?.AgentId?.split(',')?.includes(LoginCcaasUserDetails?.UserID?.toString())) {
        dispatch(ChatActions.setAgentGroupEmitter(true));
      }
      if (LoginCcaasUserDetails?.roleid == ROLES.AGENT_ROLE_ID) {
        dispatch(ChatActions.setMessage({ new: false, message: message }));
      }
      const messageText = JSON.parse(message?.message);
      const payload = {
        bcHistoryId: message?.bcHistoryId,
        message: messageText?.message,
        lastUpdated: message?.sendTimestamp,
      };
      dispatch(ChatActions.updateBroadcastGroupMessage(payload));
      // if ((rowData?.bcHistoryId == message?.bcHistoryId) && LoginCcaasUserDetails?.roleid == ROLES.AGENT_ROLE_ID) { // emmiter is used to for agent seen msg
      //   callChatService.io.emit("agent_sender", message);
      // }
    });

    callChatService.io.on("admin_receiver", (bcHistoryId: any) => { // emmiter is used to refresh for admin/superviser
      const rowData = store.getState()?.chatReducer?.rowData;
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      if ((rowData?.bcHistoryId == bcHistoryId) && LoginCcaasUserDetails?.roleid != ROLES.AGENT_ROLE_ID) {
        dispatch(ChatActions.broadcastRefresh())
      }
    })

    callChatService.io.on("admindelete_message", (data: any) => {
      dispatch(ChatActions.setMessage({
        new: false,
        deleted: true,
        message: { bcDurationHistoryId: data.bcDurationHistoryId },
      }));

      const messages = store.getState().chatReducer.broadcastmessage;

      if (messages.length > 0) {
        const lastMsg = messages[messages.length - 1];
        const parsed = JSON.parse(lastMsg.message);
        dispatch(ChatActions.updateBroadcastGroupMessage({
          bcHistoryId: data?.bcHistoryId,
          message: parsed.message,
          lastUpdated: parsed.sendTimestamp || Date.now(),
        }));
      } else {
        dispatch(ChatActions.updateBroadcastGroupMessage({
          bcHistoryId: data?.bcHistoryId,
          message: '',
          lastUpdated: Date.now()
        }));
      }
    });

    callChatService.io.on("admincreate_group", (data: any) => {
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      if (data?.bcMembers?.split(',')?.includes(LoginCcaasUserDetails?.UserID?.toString())) {
        dispatch(ChatActions.setAgentGroupEmitter(true));
      }
    });

    callChatService.io.on("customerbot_end_session", (data: any) => {
      dispatch(ChatActions.setDashPerformanceRefresh());
    });

    callChatService.io.on("CAMPAIGN_DIALOUT", (message: any) => {
      console.log("CAMPAIGN_DIALOUT :", message)
      if (message?.customer && message?.status === "initiate") {
        CallOutboundCampaignFunction(message, "");
        dispatch(outboundCampaignSliceAction.setincomingCallInfo(message))
      } else if (message?.customer && message?.status === "terminate") {
        dialPadChanges(false, false, false, false, false, false);
        dispatch(CallPopUpAgentActions.callEnded());
        const presence = sessionStorage.getItem('presence')
        presenceChangeToReady(presence)
      } else if (message?.customer && message?.status === "offline") {

        dialPadChanges(false, false, false, false, false, false);
        presenceChangeToReady("Offline")
        sessionStorage.setItem('presence', "Offline")


      } else if (message?.customer && message?.status === "cancelled") {
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail } = popUpDetails;
        const campaign: any = store.getState().outboundcampaign;
        console.log("CAMPAIGN_DIALOUT :cancelled", campaign?.incomingCallInfo?.session_id === message?.camp_session_id, "campaign?.incomingCallInfo?.session_id", campaign?.incomingCallInfo?.session_id, " message?.camp_session_id", message?.camp_session_id)

        if (campaign?.incomingCallInfo?.session_id === message?.camp_session_id) {
          if ((incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0) {
            SupervisorEndCall(incomingCallDetail?.useragent)
          }
          dispatch(CallPopUpAgentActions.callEnded());
          dialPadChanges(false, false, false, false, false, false);
          const presence = sessionStorage.getItem('presence')
          presenceChangeToReady(presence)
        }
      } else if (message?.customer && message?.status === "timeout") {
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail } = popUpDetails;
        const campaign: any = store.getState().outboundcampaign;
        console.log("CAMPAIGN_DIALOUT :timeout", incomingCallDetail, campaign?.incomingCallInfo?.session_id === message?.camp_session_id, "campaign?.incomingCallInfo?.session_id", campaign?.incomingCallInfo?.session_id, " message?.camp_session_id", message?.camp_session_id)

        if (campaign?.incomingCallInfo?.session_id === message?.camp_session_id) {
          if ((incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0) {
            SupervisorEndCall(incomingCallDetail?.useragent)
          }
          dispatch(CallPopUpAgentActions.callEnded());
          dialPadChanges(false, false, false, false, false, false);
          presenceChangeToReady("Offline")
          sessionStorage.setItem('presence', "Offline")

        }
      } else if (message?.customer && message?.status === "disconnect") {
        const popUpDetails: any = store.getState().callPopUpDetails;
        let { incomingCallDetail } = popUpDetails;
        const campaign: any = store.getState().outboundcampaign;
        console.log("CAMPAIGN_DIALOUT :disconnect", campaign?.incomingCallInfo?.session_id === message?.camp_session_id, "campaign?.incomingCallInfo?.session_id", campaign?.incomingCallInfo?.session_id, " message?.camp_session_id", message?.camp_session_id)

        if (campaign?.incomingCallInfo?.session_id === message?.camp_session_id) {
          dialPadChanges(false, false, false, false, false, false);
          // const presence = sessionStorage.getItem('presence')
          // presenceChangeToReady(presence)
          if ((incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0) {
            SupervisorEndCall(incomingCallDetail?.useragent)
          }
          dispatch(CallPopUpAgentActions.callEnded());
          hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(message?.session_id, dispatch, 0)
          dispatch(ChatActions.setCallSessionList({ state: true, sessionId: message?.session_id ?? "" }));
        }
      }

    });
    callChatService.io.on("CAMPAIGN_DIALOUT_SESSION", (message: any) => {
      dispatch(ChatActions.setCallSessionId(message?.session_id ?? ""));
      console.log("chatSessionData?.CAMPAIGN_DIALOUT_SESSION", message?.session_id)
      dispatch(outboundCampaignSliceAction.outboundCampaignclose());
      console.log("getNecessaryDetailswithsession CAMPAIGN_DIALOUT_SESSION", Date.now())
      dispatch(
        getNecessaryDetailswithsession({
          contact: message.ddi,
          sessionId: message.session_id,
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.sessionDetail?.data.statusCode === 200) {
            console.log("getNecessaryDetailswithsession CAMPAIGN_DIALOUT_SESSION", Date.now(), res?.sessionDetail?.data)
            let chatSessionData: any = res?.sessionDetail?.data?.result[0];
            chatSessionData.Number =
              chatSessionData?.callType === "outbound"
                ? chatSessionData?.calledNumber
                : chatSessionData?.customerDetails;
            // chatSessionData.calledPersonDetails = callSessionDetailswhilePopup.contactDetails;
            // chatSessionData.calledPersonDetails.tags = JSON.parse(callSessionDetailswhilePopup.contactDetails?.tags?.trim().length > 0 ? callSessionDetailswhilePopup.contactDetails?.tags : "null") ?? [];
            chatSessionData.showState = true;
            // chatSessionData.queueName = queueName ?? "Default Queue";
            // chatSessionData.queueId = queueDetails?.key;
            chatSessionData.queueName = "";
            chatSessionData.queueId = ""
            if (res?.contact?.data?.statusCode === 200) {
              chatSessionData.calledPersonDetails =
                // res.contact?.data?.getContactNumberRes[0];
                res.contact?.data?.getContactDetailsRes?.[0]|| res.contact?.data?.getContactNumberRes?.[0] 
              chatSessionData.calledPersonDetails.tags =
                typeof res?.contact?.data?.getContactNumberRes[0]?.tags ===
                  "string"
                  ? JSON.parse(
                    res?.contact?.data?.getContactNumberRes[0]?.tags?.trim()
                      .length > 0
                      ? res?.contact?.data?.getContactNumberRes[0]?.tags
                      : "null"
                  ) ?? []
                  : res?.contact?.data?.getContactNumberRes[0]?.tags;
              // JSON.parse(res?.contact?.data?.getContactNumberRes[0]?.tags?.trim().length > 0 ? res?.contact?.data?.getContactNumberRes[0]?.tags : "null") ?? [];
            } else {
              chatSessionData.calledPersonDetails = {};
            }
            dispatch(
              updateContactinSession({
                sessionId: chatSessionData.sessionId,
                calledPersonDetails: chatSessionData.calledPersonDetails,
              })
            );

            sessionStorage.setItem('currentSec', JSON.stringify(chatSessionData))
            sessionStorage.setItem('currentSecId', JSON.stringify(chatSessionData?.sessionId))
            dispatch(ChatActions.chatSessionList(chatSessionData));
            dispatch(ChatActions.currentChatSession(chatSessionData));
            dispatch(CallPopUpAgentActions.setOBCState());
            navigate("/chatscreenagent");
          }
        });
    });

    callChatService.io.on("chat_ended_for_tracker_emitter", (message: any) => {
      const fromId = `${userData?.domainId}_${userData?.ext}`;
      const { currentSession } = store.getState().chatReducer;
      if (message?.from !== fromId && message?.ChatHistoryId === currentSession?.ChatHistoryId && message?.ChatDurationHistoryId === currentSession?.ChatDurationHistoryId) {
        dispatch(ChatActions.removeCurrentSession());
        dispatch(ChatActions.currentChatSession({}));
      }
    });

  }

  static async destroy() {
    callChatService?.io?.disconnect();
  }

  static async popUpFunction(navigate: any) {
    let roomData: any = store.getState().chatReducer;
    const userDetailsData = GetItemFromStorage(LocalStorage);
    const userDetails = userDetailsData;
    let roomDetials: any = {
      room: roomData?.roomInfo,
      sessionId: roomData?.sessionId,
      agentDetails: userDetails,
    };
    let ringer: any = document.getElementById("ringer");
    ringer.pause();
    navigate("/chatscreen");
    callChatService.io.emit("joinagent", roomDetials);
    await CallServices.get(`/get_callSessionId/${roomData?.sessionId}`).then(
      (response: any) => {
        if (response.data.statusCode === 200) {
          let chatSessionData: any = response.data.result;
          chatSessionData.roomInfo = roomData.roomInfo;
          chatSessionData.customerData = response?.data.result.customerData
            ? response.data.result.customerData
            : "";
          let existingListing: any = roomData.sessionList || [];
          existingListing.push(chatSessionData);
          store.dispatch({
            type: Types.CHAT_SESSION_LIST,
            payload: {
              sessionList: existingListing,
            },
          });
          store.dispatch({
            type: Types.CURRENT_CHAT_SESSION,
            payload: {
              currentSession: chatSessionData,
            },
          });
          store.dispatch({
            type: Types.POPUP_MESSAGE,
            payload: {
              acceptRoom: false,
              roomInfo: "",
              sessionId: "",
              sessionDetailswhilePopup: "",
            },
          });
        }
      }
    );
  }
  static async getMessageList(data: any) {
    let roomData: any = store.getState().chatReducer;

    let requiredData = {
      sessionId: data?.sessionId,
      room: data.roomInfo,
    };

    await CallServices.get(`/get_callSessionId/${data?.sessionId}`).then(
      (response: any) => {
        if (response.data.statusCode === 200) {
          let chatSessionData: any = response.data.result;
          chatSessionData.roomInfo = roomData.roomInfo;
          chatSessionData.customerData = response?.data.result.customerData
            ? response.data.result.customerData
            : "";
          let existingListing: any = roomData.sessionList || [];
          let exist = false;
          existingListing.forEach((data: any) => {
            if (data.sessionId == chatSessionData?.sessionId) {
              exist = true;
            }
          });
          if (!exist) existingListing.push(chatSessionData);
          store.dispatch({
            type: Types.CHAT_SESSION_LIST,
            payload: {
              sessionList: existingListing,
            },
          });
          store.dispatch({
            type: Types.CURRENT_CHAT_SESSION,
            payload: {
              currentSession: chatSessionData,
            },
          });
        }
      }
    );

    callChatService.io.emit("getMessageList", requiredData);
  }
  static reconnect(data: any) {
    callChatService.io.emit("reconnect", data);
  }

  static callBackReject(data: any) {
    const emailId = GetItemFromStorage(LocalStorage.USER_EMAIL);
    callChatService.io.emit("callback_session", {
      ...data,
      email: emailId ?? "", device_type: "CCAAS:BROWSER",
    });
  }
  static getSessionHistory = async () => {
    await CallServices.get("/get_chat_by_endTime").then((response: any) => {
      if (response.data.statusCode === 200) {
        let resp: any = response.data.result[response.data.result.length - 1];
        let roomData = `${resp?.ipAddress}${resp?.callFlowSourceId}${resp?.sessionId}`;
        let rooms: any = [];
        callChatService.reconnect(rooms);
        callChatService.getMessageList(
          response.data.result[response.data.result.length - 1]
        );
        resp.roomInfo = roomData;
        store.dispatch({
          type: Types.CURRENT_CHAT_SESSION,
          payload: {
            currentSession:
              response.data.result[response.data.result.length - 1],
          },
        });
        store.dispatch({
          type: Types.CHAT_SESSION_LIST,
          payload: {
            sessionList: response.data.result,
          },
        });
      }
    });
  };
  static async sessioIdTransfer(id: any, dispatch: any, getAgentType: any) {
    let callData: any = {
      sessionId: id,
    };
    setTimeout(() => {
      callChatService.io.emit("joinCall", callData);
    }, 1000);
    await CallServices.get(`/get_callSessionId/${id.trim()}`).then(
      (response: any) => {
        if (response.data.statusCode === 200) {
          let chatSessionData: any = response?.data?.result[0];
          chatSessionData.showState = false;
          chatSessionData.customerData = response?.data.result[0]
            .customerDetails
            ? response.data.result[0].customerDetails
            : "";
          dispatch(ChatActions.chatSessionList(chatSessionData));
          dispatch(ChatActions.currentChatSession(chatSessionData));
        }
      }
    );
  }
  static sendReqFeatures(data: any) {
    callChatService.io.emit("bwl_switch", data);
  }
  static sendMessage(data: any) {
    const RoomData: any = store.getState().chatReducer;
    let { currentSession } = RoomData;
    const currentDate = new Date();
    const timestamp = currentDate.getTime();
    const date = new Date(timestamp);
    const time = date.getHours() + ":" + date.getMinutes();
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    let accessTokenValues = JSON.parse(userDetails);
    const messageData = {
      message: data,
      id: uuidv4(),
      timeStamp: timestamp,
      from: accessTokenValues?.ext,
      room: currentSession?.roomInfo,
      messageType: "Text",
      sessionId: currentSession?.sessionId,
      to: currentSession?.customerDetails,
    };
    callChatService.io.emit("agentmessage", messageData);
    store.dispatch({
      type: Types.UPDATE_MESSAGE,
      payload: {
        messageList: messageData,
      },
    });
  }

  static async chatTransfer(data: any) {
    callChatService.io.emit("join_to_live_agent", data);
  }
  static async chatAgentTransfer(data: any) {
    // callChatService.io.emit("transferAgenttoAgent",data);
  }
  static async transfer(data: any) {
    callChatService.io.emit("init_transfer", data);
  }
  static async agentAcceptRequest(data: any) {
    callChatService.io.emit("agentAcceptRequest", data);
  }
  static async agentDeclineRequest(data: any) {
    callChatService.io.emit("agentDeclineRequest", data);
  }
  static async agentDeclineSocialmediaRequest(data: any) {
    callChatService.io.emit("socialMediaAgentDeclineRequest", data);
  }
  static async agentAcceptSocialmediaRequest(data: any) {
    callChatService.io.emit("socialMediaAgentAcceptRequest", data);
  }
  static async assignActivityEmiiter(data: any) {
    callChatService.io.emit("assignActivityEmitter", data);
    callChatService.callDashboard(data?.domainId)
    callChatService.emailDashboard(data?.domainId)
    callChatService.smsDashboard(data?.domainId)
    callChatService.socialmediaDashboard(data?.domainId)
  }
  static async reAssignActivityEmiiter(data: any) {
    callChatService.io.emit("reAssignActivityEmitter", data);
    callChatService.callDashboard(data?.domainId)
    callChatService.emailDashboard(data?.domainId)
    callChatService.smsDashboard(data?.domainId)
    callChatService.socialmediaDashboard(data?.domainId)

  }
  static async webChatMessage(data: any) {
    console.log("OneToOneChatSend data", data);
    data["agentMsgCount"] = true;
    callChatService.io.emit("OneToOneChatSend", data);
  }
  static async storeCustomerCoid(data: any) {
    callChatService.io.emit("store_customer_data", data);
  }
  static async postMergeData(data: any) {
    callChatService.io.emit("merge_call", data);
  }

  static async agentTypingStatus(data: any) {
    callChatService.io.emit("agentTypingStatusEmitter", data);
  }

  static async postTransferData(data: any) {
    callChatService.io.emit("callTransferedRequest", data)
  }
  static async transferFrom(data: any) {
    callChatService.io.emit("callTransferFrom", data)
  }
  static async removeChatQueueUser(data: any) {
    callChatService.io.emit("removeChatQueueUser", data)
  }
  static async removeChatQueueUserSocialmedia(data: any) {
    callChatService.io.emit("removeChatQueueUserSocialmedia", data)
  }
  static async sendingtoServer(agentstatus: any) {
    callChatService.io.emit("updatedstatuslist", agentstatus);
  }
  static async refershLiveTracker() {
    callChatService.io.emit("refershLiveTracker");
  }

  static async videoMeetDecline(data: any) {
    console.log(data, "videoMeetDecline=====");

    callChatService.io.emit("videoMeetDecline", data);
  }

  static async agentMissedCallDashboard(data: any) {
    const roomData: any = store.getState().chatReducer;
    data["SourceChatDurationHistoryId"] = roomData?.internalSessionDetailswhilePopup?.ChatDurationHistoryId;
    callChatService.io.emit("agent_missed_call_dashboard", data);
  }

  static async dispositionStatusDashboard(data: any) {
    callChatService.io.emit("disposition_status_dashboard", data);
  }

  static async chatNotifyDialDuration(data: any) {
    callChatService.io.emit("chat_notify_dial_duration", data);
  }
  static async callDashboard(data: any) {
    callChatService.io.emit("dashboard_call", data);
  }
  static async emailDashboard(data: any) {
    callChatService.io.emit("dashboard_email", data);
  }
  static async smsDashboard(data: any) {
    callChatService.io.emit("dashboard_sms", data);
  }
  static async agentaAssistInsert(data: any) {
    callChatService.io.emit("insert_update_agent_assist", data);
  }
  static async socialmediaDashboard(data: any) {
    callChatService.io.emit("dashboard_socialmedia", data);
  }
  static async agentMissedCallWhatsapp(data: any) {
    callChatService.io.emit("whatsapp_agent_missed_call", data);
  }
  static async agentMissedCallFacebook(data: any) {
    callChatService.io.emit("facebook_agent_missed_call", data);
  }
  static async agentMissedCallInstagram(data: any) {
    callChatService.io.emit("instagram_agent_missed_call", data);
  }
  static async callNotifyDialDuration(data: any) {
    callChatService.io.emit("call_answered_duration", data);
  }
  static async callVoiceMail(data: any) {
    const message = JSON.stringify(data.message)
    callChatService.io.emit("callViaSmsEmail", { ...data, message });
  }
  static async callViaSmsEmail(data: any) {
    callChatService.io.emit("callViaSmsEmail", data);
  }

  static async triggerMessage(data: any) {
    const LoginUserDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const payload =
    {
      ...data,
      domain_id: LoginUserDetails?.domainId,
      ext: LoginUserDetails?.ext,
      userId: LoginUserDetails?.UserID,
    }
    callChatService.io.emit("insert_Trigger", payload);
  }
  static async languageSwitch(data: any) {
    callChatService.io.emit("language_switch", data)
  }
  static async sendAiDashboardQuery(data: any) {
    callChatService.io.emit("ai_dashboard_query", data)
  }
  static async sendAiChatDashboardQuery(data: any) {
    callChatService.io.emit("ai_chat_query", data)
  }
  static async firstAssistMessage(data: any) {
    callChatService.io.emit("first_assist_msg", data)
  }
  static async updateLogoutForCrossDomain() {
    callChatService.io.emit("update_logout_cross_domain");
  }

}

const presenceChangeToReady = (presence: any) => {
  const popUpDetails: any = store.getState().callPopUpDetails;
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  let { incomingCallDetail } = popUpDetails;
  const { agentStatus } = store.getState().agentState;
  const { users } = store.getState().userList;
  // const presence = sessionStorage.getItem('presence')
  let status: any = null
  if (agentStatus?.length > 0) {
    [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
  }
  let enableStatus: any = null
  if (users?.length > 0) {
    [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
  }
  console.log('presenceService call_service', status, enableStatus, presence);
  presenceService?.io?.emit("updatestate_backend", {
    domainId: LoginUserDetails?.domainId,
    isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1 && (popUpDetails?.incomingCallDetail ? Object.keys(popUpDetails?.incomingCallDetail ?? {}).length : 0) === 0) ? 1 : 0,
    isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
    isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
    isChatTransfer: status?.isChatTransfer ?? 0,
    isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
    isEmailTransfer: status?.isEmailTransfer ?? 0,
    stateTime: Math.floor(Date.now() / 1000),
    statusName: presence,
    ext: LoginUserDetails?.ext,
    email: LoginUserDetails?.Email,
    userId: LoginCcaasUserDetails?.UserID,
    routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
    userName: LoginCcaasUserDetails?.UserName,
    roleId: LoginCcaasUserDetails?.roleid,
    agentStatus: (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0 ? 0 : 1,
    skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
    routingMethod: enableStatus?.routingMethod ?? 0,
    inboundCall: enableStatus?.inboundCall,
    outboundCampaignCall: enableStatus?.outboundCampaignCall,
    is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
    forced_presence: 0,

  });
}